import {
  GET_MENU_STATUS,
  SET_MENU_STATUS,
} from "../constants/menu-status-constants";

export const getMenuStatus = () => ({
  type: GET_MENU_STATUS,
});

export const setMenuStatus = (status) => ({
  type: SET_MENU_STATUS,
  status,
});
